import { __ } from "@wordpress/i18n";
import React, { useEffect, useState } from 'react';
import Hint from '../components/Hint/Hint';
import PageHeading from '../components/PageHeading/PageHeading';
import TagInput from '../components/TagInput/TagInput';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../pages/withForm';
const LoginTemporaryLoginSettings = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    const [pageList,setPageList] = useState([])
    const userRoleList = ultimate_security_ajax_obj?.userRoleList || [];
    useEffect(()=>{
        setPageList([
            { code: "wp-admin", value: __( "Dashboard", 'ultimate-security' ) },
            { code: "home", value: __( "Website Home Page", 'ultimate-security' ) },
            ...(ultimate_security_ajax_obj?.pageList || []),
        ]);

    },[settingData]) 
    return (
        <>
            <div className="setting-unit px-lg" style={{marginLeft:'-30px', marginRight:'-30px'}}>
                <PageHeading 
                    title={__("Temporary Login Settings", "ultimate-security")}
                    subtitle={__("Customize your temporary login settings to fit your workflow. Define roles, set default redirection paths, and control access duration for enhanced security and flexibility.", "ultimate-security")}
                />
            </div>
            <div className="setting-unit pt-lg mt-lg pb-lg border-top pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Visible Roles", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Choose from the available roles to specify which users can be assigned temporary logins.", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex">
                                    <Hint position="top" content={__("Enable/disable user role.", "ultimate-security")}/>                                    
                                    <TagInput 
                                        name='login.settings.visible_roles' 
                                        type='role' 
                                        initialTags={settingData?.login?.settings?.visible_roles} 
                                        handleChange={handleChange} 
                                        whitelist={userRoleList}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pt-lg pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Default Role", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set Email", "ultimate-security")}/>
                                    <select 
                                        className="form-select"
                                        value={settingData?.login?.settings?.default_role} 
                                        onChange={(e) => handleChange('login.settings.default_role',e.target.value)}
                                    >
                                        {
                                            settingData?.login?.settings?.visible_roles.length && settingData?.login?.settings?.visible_roles.map(item=> (   
                                                <option 
                                                    value={item.code}
                                                    key={item.code} 
                                                >
                                                    {item.value}
                                                </option>                                     
                                            ))  
                                        }
                                    </select>
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pt-lg pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Default Redirect After Login", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set Email", "ultimate-security")}/>
                                    <select 
                                        className="form-select"
                                        value={settingData?.login?.settings?.default_redirect_to} 
                                        onChange={(e) => handleChange('login.settings.default_redirect_to',e.target.value)}
                                    >
                                        {
                                            pageList.length && pageList.map(item=> (   
                                                <option 
                                                    value={item.code}
                                                    key={item.code} 
                                                >
                                                    {item.value}
                                                </option>                                     
                                            ))  
                                        }
                                    </select>
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pt-lg pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Default Expiry Time", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Set Email", "ultimate-security")}/>
                                    <select 
                                        className="form-select"
                                        value={settingData?.login?.settings?.default_expiry_time} 
                                        onChange={(e) => handleChange('login.settings.default_expiry_time',e.target.value)}
                                    >
                                        <option value="+1 hour">{__("One Hour", "ultimate-security")}</option>
                                        <option value="+3 hour">{__("Three Hours", "ultimate-security")}</option>
                                        <option value="+1 day">{__("One Day", "ultimate-security")}</option>
                                        <option value="+3 day">{__("Three Days", "ultimate-security")}</option>
                                        <option value="+1 week">{__("One Week", "ultimate-security")}</option>
                                        <option value="+1 month">{__("One Month", "ultimate-security")}</option>
                                    </select>
                                </div>
                            </div>   
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(LoginTemporaryLoginSettings,'login.settings');